import React from "react";
import SectionTitle from "../../components/sectionTitle";
import { Box, Button, Dialog, DialogTitle, Typography } from "@mui/material";
import { useStyles } from "./indexStyles";
import { withStyles } from "@mui/styles";

function InstaPolicyConfirmationAlert({
  classes: {},
  onClose,
  onClickHandler,
  modal,
  modalKey = "alert",
}) {
  return (
    <Dialog
      onClose={(event, reason) => onClose(event, reason, modalKey)}
      aria-labelledby="simple-dialog-title"
      open={modal.alert}
      maxWidth={"md"}
    >
      <DialogTitle id="simple-dialog-title">
        <SectionTitle title={"Alert"} />
      </DialogTitle>
      <Box m={1}>
        <Box p={1}>
          <Typography variant="caption">
            Insta Policy Confirmation has already been completed for this mobile
            number. Please try with a different mobile number.
          </Typography>
        </Box>
        <Box mt={3}>
          <Button
            type={"button"}
            variant={"contained"}
            color={"primary"}
            size={"small"}
            onClick={onClickHandler}
            fullWidth
          >
            Start New Journey
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}

export default withStyles(useStyles, { withTheme: true })(
  InstaPolicyConfirmationAlert
);
